@if (file() === null) {
  <div class="drop-zone" libFileDrag (filesDropped)="setFile($event.item(0))">
    <mat-icon>upload</mat-icon>
    <button type="button" matButton="" (click)="input.click()">{{ label() }}</button>
    <input type="file" hidden (change)="file.set(input.files?.item(0) ?? null)" [accept]="accept()" #input />
  </div>
} @else {
  <div class="file-info">
    <mat-icon>check_circle</mat-icon>
    <p>{{ file()?.name ?? 'Dateiname' }}</p>
    <button type="button" (click)="setFile(null)" matIconButton [disabled]="disabled()" matTooltip="Auswahl zurücksetzen">
      <mat-icon>close</mat-icon>
    </button>
  </div>
}
